import { PowerUp, PowerUpState } from '../types';

export const createInitialPowerUps = (): PowerUpState => ({
  changeObject: {
    id: 'change_object',
    name: 'Change Object',
    description: 'Change the target or reference object to something easier',
    icon: '🔄',
    used: false
  },
  changeUnit: {
    id: 'change_unit',
    name: 'Change Unit',
    description: 'Change the measurement type (length/weight/volume)',
    icon: '📐',
    used: false
  },
  doublePoints: {
    id: 'double_points',
    name: 'Double Points',
    description: 'Get double points if within 15% accuracy',
    icon: '2️⃣',
    used: false
  },
  orderOfMagnitude: {
    id: 'order_of_magnitude',
    name: 'Order of Magnitude',
    description: 'Only need to be within 1 order of magnitude',
    icon: '📊',
    used: false
  },
  clue: {
    id: 'clue',
    name: 'Clue',
    description: 'Reveals the answer in a different measurement type',
    icon: '💡',
    used: false
  },
  skip: {
    id: 'skip',
    name: 'Skip',
    description: 'Skip this question without losing a life',
    icon: '⏭️',
    used: false
  }
});

export const getPowerUpById = (powerUps: PowerUpState, id: string): PowerUp | null => {
  const powerUpKey = Object.keys(powerUps).find(key => 
    powerUps[key as keyof PowerUpState].id === id
  ) as keyof PowerUpState | undefined;
  
  return powerUpKey ? powerUps[powerUpKey] : null;
};

export const getAvailablePowerUps = (powerUps: PowerUpState): PowerUp[] => {
  return Object.values(powerUps).filter(powerUp => !powerUp.used);
};

export const usePowerUp = (powerUps: PowerUpState, id: string): PowerUpState => {
  const newPowerUps = { ...powerUps };
  const powerUpKey = Object.keys(newPowerUps).find(key => 
    newPowerUps[key as keyof PowerUpState].id === id
  ) as keyof PowerUpState | undefined;
  
  if (powerUpKey) {
    newPowerUps[powerUpKey] = { ...newPowerUps[powerUpKey], used: true };
  }
  
  return newPowerUps;
};

// Helper function to check if answer is within order of magnitude
export const isWithinOrderOfMagnitude = (guess: number, correct: number): boolean => {
  if (guess <= 0 || correct <= 0) return false;
  
  const ratio = Math.max(guess, correct) / Math.min(guess, correct);
  return ratio <= 10; // Within 1 order of magnitude
};

// Helper function to check if answer is within 15% for double points
export const isWithin15Percent = (guess: number, correct: number): boolean => {
  if (correct === 0) return guess === 0;
  
  const percentageError = Math.abs((guess - correct) / correct) * 100;
  return percentageError <= 15;
}; 